<template>
  <ContentSection>
    <Container>
      <!-- HEADER -->
      <h2 v-if="data.heading" class="whitespace-pre-wrap font-semibold typo-h3" v-html="data.heading" />

      <!-- TEXT -->
      <div v-if="data.text" class="wysiwyg mt-4 max-w-text typo-lead" v-html="data.text" />

      <!-- FROM -->
      <FormBuilder
        :class="{ 'mt-7': data.heading || data.text }"
        :text-checkbox-conditions="textCheckboxConditions"
        :form-blueprint="data.custom_form"
        :text-submit-button="data.text_submit_button"
        :text-success="data.text_success"
        :text-error="data.text_error"
      />
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
})

provide('shouldTranslate', false)

const textCheckboxConditions = computed(() => {
  if (!props.data.show_checkbox_conditions) {
    return ''
  }

  return props.data.text_checkbox_conditions
})
</script>
